import { fieldCannotBeBlankErrorMessage } from '@ben/columbia/components/shared/constants';
import Input from '@ben/orion/input';
import Switch from '@ben/orion/switch';
import { isEmpty } from 'lodash';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { hasActiveEligibilityRule as checkHasActiveEligibilityRule } from '../../utils';
import FallbackRankSwitches from '../_common/fallback-rank-switches';
import ModularDropdownInputOptions from './modular-dropdown-input-options';

interface IModularDropdownInputProps {
  componentControllerName: string;
}

const ModularDropdownInput = ({
  componentControllerName,
}: IModularDropdownInputProps) => {
  const form = useFormContext();
  const { control } = form;

  const options = useWatch({
    control,
    name: `${componentControllerName}.options`,
  });

  const hasActiveRule = checkHasActiveEligibilityRule(options);

  const labelName = hasActiveRule
    ? 'Default value'
    : 'Default value (optional)';

  return (
    <>
      <ComponentsWrapper>
        <Controller
          name={`${componentControllerName}.defaultValue`}
          control={control}
          render={({ field, fieldState }) => (
            <Input
              {...field}
              name={labelName}
              hasError={!!fieldState.error}
              errorMessage={fieldState.error?.message}
            />
          )}
          rules={{
            validate: (value) => {
              if (hasActiveRule && isEmpty(value)) {
                return fieldCannotBeBlankErrorMessage;
              }
              return true;
            },
          }}
        />
      </ComponentsWrapper>
      <Row>
        <Controller
          name={`${componentControllerName}.showSearch`}
          control={control}
          render={({ field }) => (
            <Switch {...field} label="Show search" defaultValue={field.value} />
          )}
        />
        <FallbackRankSwitches
          componentControllerName={componentControllerName}
        />
      </Row>

      <Divider />
      <ModularDropdownInputOptions
        componentControllerName={componentControllerName}
        subTitleText="Add or edit the options to display in your dropdown component"
      />
    </>
  );
};

export default ModularDropdownInput;

const ComponentsWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;

const Divider = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 1px;
    background-color: ${theme.palette.neutral[60]};
  `}
`;

const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;
